<div class="main fx-col">
  <div class="header-container">
    <div class="filter">
      <chq-dropdown [dropdownModel]="dropdownModelFilter"  (clicked)="hideDropdown(dropdownModelFilter.name);" #filter (selected)="selectFilter($event)">
      </chq-dropdown>
      @if (input.status) {
        <chq-dropdown #status  (clicked)="hideDropdown(dropdownModelStatus.name);" [dropdownModel]="dropdownModelStatus" (selected)="selectFilter($event)">
        </chq-dropdown>
      }
      @if (input.make) {
        <chq-dropdown  (clicked)="hideDropdown(dropdownModelMake.name);" #make [dropdownModel]="dropdownModelMake" (selected)="selectFilter($event)">
        </chq-dropdown>
      }
      @if (input.provider) {
        <chq-dropdown #provider (clicked)="hideDropdown(dropdownModelWorkProvider.name);"  [dropdownModel]="dropdownModelWorkProvider"
          (selected)="selectFilter($event)">
        </chq-dropdown>
      }
      @if (input.org) {
        <chq-dropdown #org (clicked)="hideDropdown(dropdownModelOrganization.name);" [dropdownModel]="dropdownModelOrganization"
          (selected)="selectFilter($event)">
        </chq-dropdown>
      }
      @if (input.user) {
        <chq-dropdown class="user-dropdown" #user (clicked)="hideDropdown(dropdownModelUsers.name);"  [dropdownModel]="dropdownModelUsers" (selected)="selectFilter($event)">
        </chq-dropdown>
      }
      @if (input.date) {
        <chq-input [inputModel]="creationStartDateTextBox" (controlOutput)="updateInput($event)" class="date-filter">
        </chq-input>
      }
      @if (input.date) {
        <chq-input [inputModel]="creationEndDateTextBox" class="date-filter"
        (controlOutput)="updateInput($event)"></chq-input>
      }
      <chq-button [buttonModel]="applyButtonModel" >Apply</chq-button>
      <chq-button [buttonModel]="resetButtonModel" >Reset All</chq-button>
      @if (isBodyshopOrServiceAdvisor) {
        <chq-button [buttonModel]="exportButtonModel">Export</chq-button>
      }
      <a class="d-none" #exportTag [download]='downloadFileName' [href]="exportUrl"></a>
    </div>

  </div>

  <div class="table-container">
    <div class="table-wrapper">
      <xa-table [config]="tableConfig" [tableData]="tableData" [cellClicked]="handleCellClick"
        [selectAllRows]="selectAllRows" [sortChanged]="handleSortChange"
      [pageChanged]="pageChanged" [i18n]="i18n"></xa-table>
    </div>
    @if (tableData?.length > 0 && (pagination.count > pagination.pageSize)) {
      <div class="pagination-wrapper">
        <xa-paginator #paginator (paginationChange)="handlePaginationChange($event)"
          [pagination]="pagination">
        </xa-paginator>
      </div>
    }
  </div>
  <div class="footer-full-wrapper">
    <div class="footer-image-wrapper">
      <div class="image-wrapper">
        <img src="assets/img/addenda-quote.png" />
      </div>
    </div>
  </div>
</div>